document.querySelectorAll('.js-popup-share').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.open(btn.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  });
});
